import { KeyRound, PenLine, SlidersHorizontal, UserRound } from "lucide-react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";

const SECTIONS = [
  { id: "identity", label: "Identity", icon: UserRound },
  { id: "preferences", label: "Preferences", icon: SlidersHorizontal },
  { id: "signature", label: "Email signature", icon: PenLine },
  { id: "security", label: "Security", icon: KeyRound },
];

/** Left rail for /profile — page title, in-page anchor nav, and the note that
 * firm-wide settings live elsewhere. */
export function ProfileSideNav() {
  return (
    <div className="flex flex-col gap-3.5">
      <div className="px-1.5 pt-1">
        <h1 className="text-[28px] leading-tight font-semibold tracking-tight">My profile</h1>
        <p className="text-muted-foreground text-[13px]">
          Just you — how the platform looks and feels for your account.
        </p>
      </div>

      <Card className="gap-0.5 p-2.5">
        <nav className="flex flex-col gap-0.5">
          {SECTIONS.map(({ id, label, icon: Icon }) => (
            <a
              key={id}
              href={`#${id}`}
              className="text-muted-foreground hover:bg-muted flex h-[38px] items-center gap-2.5 rounded-[10px] px-3 text-sm font-medium transition-colors"
            >
              <Icon className="size-[15px]" />
              {label}
            </a>
          ))}
        </nav>
      </Card>

      <Card className="gap-1.5 rounded-lg p-4">
        <span className="text-foreground text-[13px] font-semibold">
          Firm-wide settings live elsewhere
        </span>
        <p className="text-muted-foreground text-xs leading-relaxed">
          Letters, portal, folders and integrations are under{" "}
          <Link to="/settings" className="text-info font-semibold">
            Settings
          </Link>
          . Everything on this page affects only your account.
        </p>
      </Card>
    </div>
  );
}
